import React from "react"
import "../../Main/Main.scss"
import TopBanner from "../../../components/TopBanner/TopBanner"
import PriceCalculator from "../../../components/PriceCalculator/PriceCalculator"
import LandingFeatures from "../../../components/LandingFeatures/LandingFeatures"
import LandingHelp from "../../../components/LandingHelp/LandingHelp"
import LandingContent from "../../../components/LandingContent/LandingContent"

class CityMillerovo extends React.Component {
    componentDidMount() {
        this.moveToHash()
    }

    moveToHash() {
        const hash = window.location.hash
        if ( hash ) {
            const element = document.querySelector(hash)
            if ( element ) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    render() {
        return (
            <section className="Main City-Millerovo">
                <TopBanner city={"Миллерово"} />
                <PriceCalculator />
                <LandingContent />
                <LandingFeatures />
                <LandingHelp />
            </section>
        )
    }
}

export default CityMillerovo
